import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { API, authApi, authHeaders } from "../lib/adminApi";

/**
 * Route guard for admin-only pages.
 * - If no token in localStorage → immediate redirect to /admin (no flash).
 * - If token exists → verify with GET /api/admin/me. On 401/expired,
 *   clear the token and redirect.
 */
export default function RequireAdmin({ children }) {
  const hasToken = authApi.isAuthenticated();
  const [status, setStatus] = useState(hasToken ? "checking" : "unauth");

  useEffect(() => {
    if (!hasToken) return;
    let alive = true;
    (async () => {
      try {
        await axios.get(`${API}/admin/me`, { headers: authHeaders() });
        if (alive) setStatus("ok");
      } catch (e) {
        if (!alive) return;
        authApi.logout();
        setStatus("unauth");
      }
    })();
    return () => {
      alive = false;
    };
  }, [hasToken]);

  if (status === "unauth") return <Navigate to="/admin" replace />;
  if (status === "checking") {
    return (
      <div
        className="min-h-[100dvh] flex items-center justify-center"
        data-testid="admin-guard-loading"
      >
        <div className="glass-strong rounded-2xl px-5 py-4 text-sm font-semibold text-slate-600">
          Verifying admin session…
        </div>
      </div>
    );
  }
  return children;
}
